module.exports = __webpack_public_path__ + "img/orange_034.b55cb166.png";